import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

import UAParser from 'ua-parser-js'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'

import BaseStore from '../../store/baseStore'

Vue.use(Vuex)
Vue.use(VueResource)

dayjs.extend(weekday)
dayjs.extend(utc)

const baseStore = new BaseStore()

const state = {
  ...baseStore.state,
  cta: 'Bonjour, comment pouvons-nous vous aider ?'
}
const getters = {
  ...baseStore.getters
}
const actions = {
  ...baseStore.actions,
  initAvailableTrees: ({ commit, dispatch, getters }, data) => {
    return new Promise((resolve, reject) => {
      const isAvailable = (tree) => {
        return new Promise((resolve, reject) => {
          if (tree.action !== 'Widget') {
            resolve(false)
          }
          if (tree.target.indexOf('whatsapp') > -1 &&
              data.$settings.ua.isMobile === false) {
            resolve(false)
          } else if (tree.target.indexOf('apple-business-chat') > -1 &&
              data.isABCSupported === false) {
            resolve(false)
          } else if (tree.target.indexOf('data-gb-service="zenbot"') > -1) {
            let url
            const tag = document.createElement('div')
            tag.innerHTML = tree.target
            const btnTag = tag.querySelector(
              'button[data-gb-service="zenbot"][data-gb-agent-skills]')
            if (btnTag !== null) {
              const uuids = btnTag.getAttribute(
                'data-gb-agent-skills').split(',')

              const testAgentsAvailability = async () => {
                let count = 0
                for (let i = 0; i < uuids.length; i++) {
                  const uuid = uuids[i]
                  url = `https://agent.greenbureau.com/api/guests/load/${uuid.trim()}/`
                  const response = await Vue.http.get(url)
                  // console.log('RESPONSE', response)
                  // response.bodyText = 'busy'
                  if (response.bodyText !== 'online') {
                    // console.log('RTYU')
                    count++
                  }
                }
                // console.log('TRUC', count, uuids)
                if (count === uuids.length) {
                  return false
                }
                return true
              }

              testAgentsAvailability().then((ret) => {
                // console.log('RET', ret)
                resolve(ret)
              })
            }
          } else {
            resolve(true)
          }
        })
      }
      const trees = []
      let x = 0

      const loopTrees = (arr) => {
        appendTree(arr[x], () => {
          // set x to next item
          x++

          // any more items in array? continue loop
          if (x < arr.length) {
            loopTrees(arr)
          } else {
            commit('setAvailableTrees', trees)
            // console.log('FINAL', trees)
            resolve(true)
          }
        })
      }

      const appendTree = (item, callback) => {
        isAvailable(item).then(availability => {
          if (availability === true) {
            if (item.target.indexOf('apple-business-chat') > -1) {
              const group = data.group
              const language = document.querySelector('html').getAttribute('lang')
              const newNode = document.createElement('div')
              newNode.setAttribute('class', 'wrapper')
              newNode.innerHTML = item.target.replace(':group-id:', group)
              newNode.querySelector('div').setAttribute('data-apple-business-body',
                newNode.querySelector('div').getAttribute(`data-gb-body-${language}`))
              item.target = newNode.innerHTML
            }
            trees.push(item)
          }
        }).then(() => {
          if (callback !== undefined) {
            callback()
          }
        })
      }
      loopTrees(getters.trees)
    })
  }
}
const mutations = {
  ...baseStore.mutations,
  initial (state, params) {
    state.account = params.account
    state.hideCtaDelay = 10
    state.showCtaDelay = 3
    state.autoOpen = 3

    const MOBILE_DEVICES = ['mobile', 'tablet', 'wearable', 'embedded']
    const parser = new UAParser()
    const res = parser.getResult()
    const model = res.device.model || 'PC'
    const isMobile = MOBILE_DEVICES.indexOf(res.device.type) > -1

    let windowUrl
    if (process.env.VUE_APP_WINDOW_URL === undefined) {
      windowUrl = window.location.href
    } else {
      windowUrl = process.env.VUE_APP_WINDOW_URL
    }
    state.windowUrl = windowUrl
    state.ua = {
      browser: res.browser.name,
      model: model,
      device: `${model}/${res.os.name}`,
      language: window.navigator.language,
      isMobile: isMobile
    }

    state.isOpen = params.is_open
    if ('title' in params) {
      state.title = params.title
    }
    if ('trees' in params) {
      state.trees = params.trees
    }
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
